<main>
  <form #form method="post" action="{{ cardSsoUrl }}" [hidden]="true">
    <input
      type="text"
      id="SAMLResponse"
      name="SAMLResponse"
      placeholder="SAMLResponse"
      value="{{ saml }}"
    />
    <input
      type="text"
      id="RelayState"
      name="RelayState"
      value="{{ authDomian }}"
    />
    <input
      id="submit-button"
      type="submit"
      value="Submit"
      (click)="form.submit()"
    />
  </form>

  <app-egg-spinner-overlay></app-egg-spinner-overlay>
</main>
